export { default as actions } from './actions';
export { default as consts } from './constants';
export { default as reducer } from './reducer';



// WEBPACK FOOTER //
// ./src/redux/modules/settings/index.ts